import React from 'react';
import BarSplitChart from './BarSplitChart';

const SupplierGroupSplitChart = () => (
  <BarSplitChart
    title="Split Over Supplier Group"
    endpoint="/dashboard/supplier-group-split"
    cornerLabel="top groups"
    barColor="var(--dash-chart-4)"
    maxRows={7}
  />
);

export default SupplierGroupSplitChart;
